export enum VoOppPermissions {
  VoOpp = 'vo-opp',
  Opp = 'opp',
}
